import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@ria-client/tw-shadcn/components/table';
import { ScrollableRegion } from '@ria-client/tw-shared-ui/layout/scrollable-region';
import type { ReactNode } from 'react';

export type RiaTableRow = { id: string; cells: ReactNode[] };

export type RiaTableProps = {
  'aria-label': string;
  columns: ReactNode[];
  rows: RiaTableRow[];
  footer?: ReactNode;
  preserveFirstColumnLineBreaks?: boolean;
  rowHeaderColumn?: boolean;
};

export function RiaTable({
  'aria-label': ariaLabel,
  columns,
  rows,
  footer,
  preserveFirstColumnLineBreaks = true,
  rowHeaderColumn = false,
}: RiaTableProps) {
  return (
    <ScrollableRegion aria-label={ariaLabel} className="border-t-2 border-primary">
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((column, columnIndex) => (
              <TableHead
                key={columnIndex}
                scope="col"
                className="advisor-search-table-header font-bold [&_*]:font-bold"
              >
                {column}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.id} className="hover:[&_td]:bg-secondary">
              {row.cells.map((cell, cellIndex) => (
                <TableCell
                  key={cellIndex}
                  scope={cellIndex === 0 && rowHeaderColumn ? 'row' : undefined}
                  className={
                    cellIndex === 0
                      ? `advisor-search-table-cell align-top font-bold${preserveFirstColumnLineBreaks ? ' whitespace-pre-line' : ''}`
                      : 'advisor-search-table-cell align-top'
                  }
                >
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {footer}
    </ScrollableRegion>
  );
}
